export const getColumnOrder = (jsonSettings: any): string[] => {
  if (!jsonSettings) {
    return []
  }

  if (Array.isArray(jsonSettings)) {
    return jsonSettings
  }

  return jsonSettings.order || []
}
